import addDays from "date-fns/addDays";
import moment from "moment";

export interface iStatementFilter {
    From: string;
    To: string;
    CustomerID: number;
    StatementNo: string;
}

export class StatementFilter {
    From: string;
    To: string;
    CustomerID: number;
    StatementNo: string;

    constructor();
    constructor(obj: iStatementFilter);	
    constructor(obj?: iStatementFilter) { 
        this.From = moment(obj?.From ?? addDays(new Date(), -7)).format();
        this.To = moment(obj?.To ?? new Date()).format();
        this.CustomerID = obj?.CustomerID ?? 0;
        this.StatementNo = obj?.StatementNo ?? "";
    }
}